module.exports = __webpack_public_path__ + "static/media/circle-chevron-left-grey.43e9f6de.png";